<template>
    <div class="MaintainCreate">
        <div class="create_input">
            <div class="name_style house_number">
                <div>通報戶號:</div>
                <input type="text" class="form-control" v-model.trim="house_number" placeholder="通報戶號" disabled>
            </div>
            <div class="name_style notify_name">
                <div>通報人名:</div>
                <input type="text" class="form-control" v-model.trim="notify_name" placeholder="通報人">
            </div>
        </div>
        <div class="create_input">
            <div class="name_style contact_number">
                <div>連絡電話:</div>
                <input type="text" class="form-control" v-model.trim="contact_number" placeholder="連絡電話">
            </div>
            <div class="name_style notify_time">
                <div>通報時間:</div>
                <input type="text" class="form-control" v-model.trim="notify_time" placeholder="通報時間" disabled>
            </div>
        </div>
        <div class="create_input">
            <div class="notify_time">
                <div>通報內容:</div>
                <textarea rows="4" cols="50" v-model.trim="notify_content" placeholder="通報內容..."></textarea>
            </div>
        </div>
        
        <!-- 圖片上傳 -->
        <div class="upimg_content">
            <div class="upimg_title">
                <p>上傳1張照片( jpg、png照片 )</p>
            </div>
            <div class="img_content">
                <div class="show_img mb-1" style="margin-right: 10px" v-for="item, idx in img_previews" :key="idx">
                    <button @click="del_img(idx)" class="img_x">X</button>
                    <img class="show_this_img" :src="item">
                </div>
                <div class="mb-1" v-show="none_upimg == 1">
                    <label for="upload" class="btn-upload">
                        <img :src="no_img">
                        <input hidden multiple="multiple" id="upload" type="file" accept="image/jpeg,image/jpg,image/png" @change="imgUpData">
                    </label>
                </div>
            </div>
        </div>

        <div class="create_btn">
            <button class="btn btn-primary" @click="this_submit">
                送出
            </button>
            <button class="btn btn-secondary" @click="this_cancel">
                返回
            </button>
        </div>
    </div>
</template>

<script>
import "@/assets/css/member/maintain/maintainCreate.css";

export default {
    name: "MaintainCreate",
    data () {
        return {
            house_number: localStorage.getItem('house_number'), //通報戶號
            notify_name: '', //通報人
            contact_number: '', //連絡電話
            notify_time: '', //通報時間
            notify_content: '', //通報內容
            //
            no_img: require('@/assets/images/btn-upload.png'),
            img_previews_length: 1,
            img_previews: [],
            push_imgs:[],
            none_upimg: 1
        }
	},
    beforeMount: function () {
        const today = new Date();
        function add_zero (time) {
            if (time < 10) {
                return '0' + time;
            } else {
                return time;
            }
        }
        this.notify_time = today.getFullYear()+'-'+add_zero((today.getMonth()+1))+'-'+add_zero(today.getDate())+'-'+add_zero(today.getHours())+':'+add_zero(today.getMinutes());
        if (this.$route.name == 'MemberHome' && !localStorage.getItem('house_number') && this.$store.state.house_number == null) {
            this.$router.push({ name: 'Login' });
        } else {
            const getData = new FormData();
            getData.append('CMD', 'FrontMemberHomeMaintainCreate');
            if (localStorage.getItem('house_number') != null) {
                getData.append('house_number', localStorage.getItem('house_number'));
            }
            getData.append('type', 'getData');
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                console.log(response);
                const get_data = response.data.user_name;
                this.notify_name = get_data.user_name;
                this.contact_number = get_data.user_phone;
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    methods: {
        imgUpData: function (event) {
            console.log(123)
            let input = event.target;
            let count = input.files.length;
            let img_type = input.files.item(0).type;    //副檔名
            let img_size = Math.ceil((input.files.item(0).size / 1024) / 1024); //計算檔案大小
            let index = 0;
            switch (img_type) {
                case "image/jpeg":
                case "image/jpg":
                case "image/png":
                    if (img_size > 10) {
                        alert('檔案過大');
                    }
                    else {
                        if (input.files) {
                            if (count > this.img_previews_length) {
                                alert('檔案數量過多');
                                return;
                            } else {
                                if ((this.img_previews.length + count) >= (this.img_previews_length + 1)) {
                                    alert('檔案數量過多');
                                    return;
                                } else {
                                    while(count --) {
                                        let reader = new FileReader();
                                        reader.onload = (e) => {
                                            this.img_previews.push(e.target.result);
                                        }
                                        reader.readAsDataURL(input.files[index]);
                                        index ++;
                                    }
                                }
                            }
                        }
                    }
                    break;
            
                default:
                    alert('格式錯誤');
                    break;
            }
        },
        del_img: function(idx) {
            let yes_del = confirm('確定刪除此照片');
            if (yes_del) {
                this.img_previews.splice(idx, 1);
                if (this.img_previews.length <= this.img_previews_length) {
                    this.none_upimg = 1;
                }
            }
        },
        this_cancel () {
            this.$router.push({ name: 'MaintainList'});
        },
        this_submit () {
            const today = new Date();
            function add_zero (time) {
                if (time < 10) {
                    return '0' + time;
                } else {
                    return time;
                }
            }
            if (this.house_number == '' || this.notify_name == '' || this.contact_number == '' || this.notify_content == '') {
                alert('請輸入相關資訊');
            } else {
                var yes_submit = confirm('確定報修？');
                if (yes_submit) {
                    const the_number = today.getFullYear()+add_zero((today.getMonth()+1))+add_zero(today.getDate())+add_zero(today.getHours())+add_zero(today.getMinutes())+this.house_number;
                    const addData = new FormData();
                    addData.append('imgs', JSON.stringify(this.img_previews));
                    addData.append('CMD', 'FrontMemberHomeMaintainCreate');
                    addData.append('type', 'CreateAdd');
                    addData.append('house_number', localStorage.getItem('house_number'));
                    addData.append('notify_name', this.notify_name);
                    addData.append('notify_number', the_number);
                    addData.append('contact_number', this.contact_number);
                    addData.append('notify_time', this.notify_time);
                    addData.append('notify_content', this.notify_content);
                    this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, addData)
                    .then(response => {
                        // console.log(response);
                        if (response.data.result == true) {
                            alert('報修成功');
                            this.$router.push({ name: 'MaintainList'});
                        } else {
                            console.log(response.data.error);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }
            }
        }
    },
    watch: {
        img_previews () {
            if (this.img_previews.length >= this.img_previews_length) {
                this.none_upimg = 0;
            } else if (this.img_previews.length <= this.img_previews_length) {
                this.none_upimg = 1;
            }
        }
    }
}
</script>

<style>
    
</style>